import { apiClient } from '@doda/api-client/util/apiClient';
import { Methods as JobSearchListRequestType } from '@doda/api-client/aspida/api/v1/jobs';
import { JobListResponse } from '@doda/api-client/aspida/@types';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { IncomingHttpHeaders } from 'http';

/**
 * 求人一覧取得処理
 * @param params
 * @param offset
 * @param headers HTTPヘッダー
 * @returns 求人一覧
 */
export const getJobListForTrend = async (
  params: JobSearchListRequestType['get']['query'],
  offset: number,
  headers?: IncomingHttpHeaders
) => {
  const res = await apiClient.api.v1.jobs.$get({
    query: {
      ...params,
      limit: 20,
      offset,
    },
    config: { headers },
  });
  return res;
};

/**
 * 共通求人一覧取得処理
 * @param params
 * @param offset
 * @returns 求人一覧
 */
const getJobListForTrendCommon = async (
  params: JobSearchListRequestType['get']['query'],
  offset: number
) => {
  try {
    const jobSearchList = await getJobListForTrend(params, offset);
    return jobSearchList;
  } catch {
    throw new Error('求人一覧requirementsの取得に失敗しました');
  }
};

/**
 * エラーレスポンス
 * @param message エラーメッセージ
 * @param redirect リダイレクト要否
 */
export interface RejectedValue {
  message: string;
  redirect: boolean;
}

export const getJobListForTrendRequirements = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
  }
>(
  'getJobListForTrend/getJobListForTrendRequirements',
  async ({ params, offset }) => {
    const jobSearchList = await getJobListForTrendCommon(params, offset);
    return jobSearchList;
  }
);

export const getJobListForTrendWorkplaceEnvironment = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
  }
>(
  'getJobListForTrend/getJobListForTrendWorkplaceEnvironment',
  async ({ params, offset }) => {
    const jobSearchList = await getJobListForTrendCommon(params, offset);
    return jobSearchList;
  }
);

export const getJobListForTrendIncome = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
  }
>('getJobListForTrend/getJobListForTrendIncome', async ({ params, offset }) => {
  const jobSearchList = await getJobListForTrendCommon(params, offset);
  return jobSearchList;
});

export const getJobListForTrendHolidayAndWayOfWorking = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
  }
>(
  'getJobListForTrend/getJobListForTrendHolidayAndWayOfWorking',
  async ({ params, offset }) => {
    const jobSearchList = await getJobListForTrendCommon(params, offset);
    return jobSearchList;
  }
);

export const getJobListForTrendEmployeeAverageAge = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
  }
>(
  'getJobListForTrend/getJobListForTrendEmployeeAverageAge',
  async ({ params, offset }) => {
    const jobSearchList = await getJobListForTrendCommon(params, offset);
    return jobSearchList;
  }
);

export const getJobListForTrendEmploymentStatus = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
  }
>(
  'getJobListForTrend/getJobListForTrendEmploymentStatus',
  async ({ params, offset }) => {
    const jobSearchList = await getJobListForTrendCommon(params, offset);
    return jobSearchList;
  }
);

export const getJobListForTrendWelfareBenefits = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
  }
>(
  'getJobListForTrend/getJobListForTrendWelfareBenefits',
  async ({ params, offset }) => {
    const jobSearchList = await getJobListForTrendCommon(params, offset);
    return jobSearchList;
  }
);

export const getJobListForTrendLanguageAndPositions = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
  }
>(
  'getJobListForTrend/getJobListForTrendLanguageAndPositions',
  async ({ params, offset }) => {
    const jobSearchList = await getJobListForTrendCommon(params, offset);
    return jobSearchList;
  }
);

export const getJobListForTrendEstablish = createAsyncThunk<
  JobListResponse,
  {
    params: JobSearchListRequestType['get']['query'];
    offset: number;
  }
>(
  'getJobListForTrend/getJobListForTrendEstablish',
  async ({ params, offset }) => {
    const jobSearchList = await getJobListForTrendCommon(params, offset);
    return jobSearchList;
  }
);
